import { pushEventToParent } from "../../../Utils/eventUtils";
import { captureException } from "../../../Utils/sentryUtils";

export const handleNudgeClick = (nudge: any): void => {
  try {
    pushEventToParent({
      eventCode: nudge.triggerEvent || nudge.category,
    });
  } catch (error) {
    console.error('Error tracking nudge clicked:', error);
    captureException(error);
  }
};